import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import playcanvas from './scripts/playcanvas';

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

async function start() {
    await playcanvas.start(0, () => {
        document.getElementById("hero").classList.add("playcanvas-loaded")
    });
    playcanvas.app.on("learn-more-clicked", function (project) {
        if (!location.href.includes("#"))
            location.href = location.href + "#" + project;
    })
}

start();
